import { useGetSite } from 'api/sites';
import { DEFAULT_DATE_FORMAT } from 'utils/dateFormatter';
import useTenantSelection from 'hooks/useTenantSelection';

/**
 * The date format configured on the selected site, as a .NET-style pattern (e.g. "dd/MM/yyyy").
 *
 * Date format is a site setting, so anything showing a date depends on the header's site selection.
 * Centralised here so callers don't repeat the lookup and its fallback — and so they all fall back
 * to the same thing when no site is selected or its settings haven't loaded.
 */
export default function useSiteDateFormat(): string {
  const { selectedCompanySiteResult } = useTenantSelection();
  const { site } = useGetSite(selectedCompanySiteResult?.siteId ?? null);

  return site?.siteSettings?.dateFormat || DEFAULT_DATE_FORMAT;
}
